import { IPaginationInfo } from 'types/pagination'

export enum ESubmissionEvaluationStatus {
  UNDER_EVALUATION = 'UNDER_EVALUATION',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  REJECTED = 'REJECTED',
  FINISHED = 'FINISHED',
}

export type SubmissionEvaluationParams = {
  submissionId?: string
  tenderId?: string
  statuses?: string[]
}

export type ISubmissionEvaluation = {
  id: string
  submitterOrganizationId: string
  tenderId: string
  offerPriceNotes: string
  offerDurationNotes: string
  offerGuaranteeNotes: string
  offerGuaranteeDurationNotes: string
  offerAgreementExecutionGuaranteeNotes: string
  technicalSubmissionNotes: string
  technicalEvaluationScore: number
  procurementEvaluationScore: number
  createdAt: string
  completedAt: string
  submittedAt: string
  evaluationStatus: ESubmissionEvaluationStatus
  submissionOrganizationName: string
  calculatedScore: number
  totalScore: number
  submissionEvaluationId: string
  status: ESubmissionEvaluationStatus
  submissionId: string
  submissionCreatedDate: string
  submitterOrganizationName: string
  winner: boolean
  evaluationId?: string
  totalPrice: number
}

export type ISubmissionEvaluations = {
  items: ISubmissionEvaluation[]
  info: IPaginationInfo
}

export type ISubmissionEvaluationExtended = {
  id: string
  submissionId: string
  submitterOrganizationId: string
  tenderId: string
  offerPriceNotes: string
  offerDurationNotes: string
  offerGuaranteeNotes: string
  offerGuaranteeDurationNotes: string
  offerAgreementExecutionGuaranteeNotes: string
  technicalSubmissionNotes: string
  technicalEvaluationScore: number
  procurementEvaluationScore: number
  createdAt: string
  completedAt: string
  submittedAt: string
  evaluationStatus: ESubmissionEvaluationStatus
  submissionOrganizationName: string
  totalScore: number
}
